// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#sitemap[data-v-31563dd1]{margin:2rem auto;max-width:62rem;padding:1rem;width:100%}.subsection[data-v-31563dd1]{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:1rem;gap:1rem}.heading-link[data-v-31563dd1]{color:inherit}.links[data-v-31563dd1]{display:flex;flex-direction:column;min-width:30%}@media screen and (max-width:640px){.subsection[data-v-31563dd1]{grid-template-columns:1fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
